import { ConciergeServicePageView } from '@/lib/pages/concierge';
import { getConciergePageStaticProps } from '@/lib/pages/concierge/get-static-props';

import { getConciergeThailandElitePage } from '@/lib/entities/concierge/server-content';
import { SeoEntries } from '@/lib/entities/seo/lib/seo-entries';

import { InferGetStaticPropsType } from 'next';

const PATH = '/concierge/thailand-elite';

export default function ThailandElitePage({
  page,
  locale,
  pageSeo,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <>
      <SeoEntries
        fallback={{
          title: page.metaTitle,
          description: page.metaDescription,
          keywords: 'thailand privilege phuket concierge',
          openGraphImage: '/images/og.png',
        }}
        seo={pageSeo}
        language={locale}
        path={PATH}
      />
      <ConciergeServicePageView page={page} locale={locale} h1={pageSeo?.h1} />
    </>
  );
}

export const getStaticProps = getConciergePageStaticProps(
  getConciergeThailandElitePage,
  PATH
);
